import { Config } from "@/shared/types/config";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type ConfigState = {
  config: Config | null;
  isSendEmail: boolean;
};

type ConfigAction = {
  setConfig: (config: Config) => void;
  setIsSendEmail: (isSendEmail: boolean) => void;
  clearConfigStore: () => void;
};

const initialConfig: ConfigState = {
  config: null,
  isSendEmail: false,
};

export const useConfigStore = create<ConfigState & ConfigAction>()(
  persist(
    (set) => ({
      ...initialConfig,
      setConfig: (config: Config) => set(() => ({ config })),
      setIsSendEmail: (isSendEmail: boolean) => set(() => ({ isSendEmail })),
      clearConfigStore: () => set({ ...initialConfig }),
    }),
    {
      name: "config-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
